import React from 'react';
import WName, {WArticle} from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, TLDR} from '../common';

// Banning only works in finitude
export const ban = {
  name: "ban",
  alternatives: "banning,bans",
  prelude: <span>
    But if you can <i>outlaw</i> everything Unsafe<sup>®</sup>, like EVERYTHING???
  </span>,
  header: <span>
    It is mathematically impossible to reduce non-finitude by restriction.<sup>†</sup>
  </span>,
  headerFootnote: <span>† Unless you impose a φ-rule that restricts it to finitude.</span>,
  outside: <span>
    <LRL name="containment">Containment-mindedness</LRL> only works if you can list something entirely in. Trying to reach ‘safety’ by <i>restriction</i> (i.e. <QL name="tm">Safety<sup>®</sup></QL>) is reducing – on <LRL name="gaia">Planet Earth</LRL> – the <PL>non-finite</PL> potential of <NW>God</NW> (<QL>consciousness</QL>: the <LRL>imagination</LRL>) to finitude, cf. the <LRL name="nepantla.">CT</LRL> and the literal <i><AL>war</AL></i> we are in against not a ‘<LRL>them</LRL>’, but <AL name="system">systemic</AL> <LRL>reactivity</LRL>).
  </span>,
  preview: <div className="problem-preview">
    <p>Under construction.</p>
  </div>,
//  text: <div className="problem-text">
//  </div>,
};
